import { ESeoDataActionType } from '../actions/seo';
import { TReduxActions } from '../types/redux';
import { ISeoData } from '../types/seo';

const defaultState = null;

export const seoDataReducer = (state: ISeoData | null = defaultState, action: TReduxActions): ISeoData | null => {
  switch (action.type) {
    case ESeoDataActionType.SetData: {
      return action.payload;
    }
    default:
      return state;
  }
};
